import { combineReducers, configureStore } from '@reduxjs/toolkit';
import thunk, { ThunkMiddleware } from 'redux-thunk';
import consultationsReducer from './consultations/reducer';
import consultationsNewListReducer from './consultations/newList.reducer';
import deletedSessionsReducer from './consultations/deletedSessions.reducer';
import { consultationsMiddleware } from './consultations/middleware';
import specialistReducer from './specialists/reducer';
import userReducer from './user/reducer';
import tabBarReducer from './tabBar/reducer';
import animationReducer from './animation/reducer';
import internetConnectionReducer from './internetConnection/reducer';
import psychologistCalenderReducer from './calendarData/reducer';
import isIosReducer from './isIos/reducer';
import firestoreGlobalVariables from './firestoreGlobalVariables/reducer';
import usersPsychologistsReducer from './usersPsychologists/reducer';
import savedCreditCardsReducer from './savedCreditCards/reducer';
import initialLoading from './initialLoading/reducer';
import chatMessages from './chatMessages/reducer';
import liveUpdatePopupReducer from './liveUpdatePopup/reducer';
import chatRoomsSlice from './chatRooms/reducer';
import subscriptions from './subscriptions/reducer';
import subscriptionsInfo from './subscriptionsInfo/reducer';
import pushNotifications from './pushNotifications/reducer';
import supportButton from './supportButton/reducer';
import onBoardingReducer from './onBoarding/reducer';
import specialistReviewsReducer from './specialistReviews/reducer';
import seiingsModalReducer from './settingsModal/reducer';
import avatarModalReducer from './avatarModal/reducer';
import mergeUser from './mergeUser/reducer';
import favouriteSpecialists from './favouriteSpecialits/reducer';
import needReview from './needReview/reducer';
import auth from './auth/reducer';
import consultationsReviews from './consultationReviews/consultationsReviews.reducer';
import promoCodes from './promoCodes/promoCodes.reducer';
import loadedSpecialists from './loadedSpecialists/reducer';
import onBoardingFlow from './onBoardingFlow/reducer';
import sessionStorageMiddleware from './sessionStorageMiddleware';
import videoCall from './videoCall/reducer';
import chat from './chat/reducer';
import mindlyReviewsReducer from './mindlyReviews/reducer';

const combinedReducer = combineReducers({
  specialists: specialistReducer,
  isIos: isIosReducer,
  user: userReducer,
  consultations: consultationsReducer,
  consultationsNewList: consultationsNewListReducer,
  deletedSessions: deletedSessionsReducer,
  tabBar: tabBarReducer,
  animation: animationReducer,
  internetConnection: internetConnectionReducer,
  psychologistCalender: psychologistCalenderReducer,
  firestoreGlobalVariables,
  usersPsychologists: usersPsychologistsReducer,
  savedCreditCards: savedCreditCardsReducer,
  initialLoading,
  chatMessages,
  liveUpdatePopup: liveUpdatePopupReducer,
  chatRooms: chatRoomsSlice,
  subscriptions,
  subscriptionsInfo,
  pushNotifications,
  supportButton,
  onBoarding: onBoardingReducer,
  specialistReviews: specialistReviewsReducer,
  settingsModal: seiingsModalReducer,
  avatarModal: avatarModalReducer,
  mergeUser,
  favouriteSpecialists,
  needReview,
  auth,
  consultationsReviews,
  promoCodes,
  loadedSpecialists,
  onBoardingFlow,
  videoCall,
  chat,
  mindlyReviews: mindlyReviewsReducer,
});

export const rootReducer = (state: any, action: any) => {
  if (action.type === 'user/logout') {
    state = undefined;
  }
  return combinedReducer(state, action);
};

export type RootState = ReturnType<typeof rootReducer>;
const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      thunk as ThunkMiddleware<RootState>,
      sessionStorageMiddleware,
      consultationsMiddleware,
    ]),
  devTools: import.meta.env.DEV,
});

export type AppDispatch = typeof store.dispatch;

export type AppThunk = (dispatch: AppDispatch, getState: () => RootState, extraArgument: unknown) => void;

export default store;

//@ts-ignore
declare module 'react-redux' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  export interface DefaultRootState extends RootState {}

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  export function useDispatch<TDispatch = AppDispatch>(): AppDispatch;

  export function useSelector<TState = RootState, TSelected = unknown>(
    selector: (state: TState) => TSelected,
    equalityFn?: (left: TSelected, right: TSelected) => boolean
  ): TSelected;
}
